export default "__VITE_ASSET__BdnymrON__"